document.querySelectorAll('.investors_details_main').forEach((section) => {
  const tabButtons = section.querySelectorAll('.investors_details_tab');
  const tabContents = section.querySelectorAll('.investors_details_content_item');
  let currentIndex = Array.from(tabContents).findIndex(el => el.classList.contains('active'));
  let isAnimating = false;
  tabContents.forEach((content, index) => {
    content.style.display = content.classList.contains('active') ? 'block' : 'none';
  });
  tabButtons.forEach((btn, index) => {
    btn.addEventListener('click', () => {
      if (isAnimating || index === currentIndex) return;
      isAnimating = true;
      tabButtons.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      const current = tabContents[currentIndex];
      current.classList.remove('active');
      setTimeout(() => {
        current.style.display = 'none';
        const next = tabContents[index];
        next.style.display = 'block';
        setTimeout(() => {
          next.classList.add('active');
          currentIndex = index;
          isAnimating = false;
        }, 10);
      }, 300);
    });
  });
  const accordionMenuToggles = section.querySelectorAll('.investors_accordion_title');
  accordionMenuToggles.forEach(toggle => {
    toggle.addEventListener('click', function() {
      const content = this.nextElementSibling;
      const isActive = this.classList.contains('active');
      accordionMenuToggles.forEach(t => {
        t.classList.remove('active');
        t.nextElementSibling.classList.remove('active');
        t.nextElementSibling.style.height = '0';
      });
      if (!isActive) {
        this.classList.add('active');
        content.classList.add('active');
        content.style.height = 'auto';
        const fullHeight = content.scrollHeight + 'px';
        content.style.height = '0';
        setTimeout(() => {
          content.style.height = fullHeight;
        }, 10);
      }
    });
  });
});
